export const generateObjectId = (canvasId: string): string => {
  return `${canvasId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
